// configs

<template>
	<v-container fluid ma-0 pa-0>
	<v-card dark tile flat>
		<v-toolbar
			color="blue-grey darken-3"
			dark
			flat tile dense extension-height="35px"
		>
			<v-toolbar-title dense class="font-weight-light">Configuration</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn-toggle mandatory v-model="cfgMode" background-color="blue-grey darken-2"
				@change="cfgModeChanged($event)"
			>
				<v-btn small value="list-sort">list-sort</v-btn>
				<v-btn small value="list-cfg">list-cfg</v-btn>
				<v-btn small value="form-sort">form-sort</v-btn>
				<v-btn small value="form-cfg">form-cfg</v-btn>
			</v-btn-toggle>
			<v-spacer></v-spacer>
			<v-btn small class="green" :disabled="!isDirty" @click="onReload">Cfg Reload</v-btn>
			<template v-slot:extension>
				<v-tabs
					v-model="htab"
					align-with-title centered
					color="grey"
					background-color="transparent"
					slider-color="grey"
                    active-class="blue-grey darken-1 black--text"
                    dark dense height="35px"
					next-icon="mdi-arrow-right-bold-box-outline"
					prev-icon="mdi-arrow-left-bold-box-outline"
					show-arrows show-arrows-on-hover center-active
					@change="htabChanged($event)"
				>
					<v-tab v-for="(item, hindex) in items" :key="hindex">
						{{ item.table_name }}
					</v-tab>
				</v-tabs>
			</template>
		</v-toolbar>
		<v-tabs-items v-model="htab">
			<v-tab-item v-for="(item, hindex) in items" :key="hindex">			
		        <v-tabs v-model="vtab[hindex]" vertical dense @change="htabChanged($event)"
					background-color="blue-grey darken-3" color="grey" active-class="blue-grey darken-1 black--text">
			        <v-tab v-for="(subitem, vindex) in item.cfgreftables" :key="vindex" style="height: 35px; font-size: 10px !important;">
				        {{ subitem.reftable }}
			        </v-tab>
                    <v-tab-item v-for="(subitem, vindex) in item.cfgreftables" :key="vindex">
						<ListSort v-if="htab == hindex && vtab[hindex] == vindex && cfgMode == 'list-sort'"
							:ctx="{ table: item.table_name, ref: subitem.reftable }" @dying="childLSDying($event)"
						></ListSort>
						<ListConfig v-if="htab == hindex && vtab[hindex] == vindex && cfgMode == 'list-cfg'"
							:ctx="{ table: item.table_name, ref: subitem.reftable }" @dying="childLCDying($event)"
						></ListConfig>
						<FormSort v-if="htab == hindex && vtab[hindex] == vindex && cfgMode == 'form-sort'"
							:ctx="{ table: item.table_name, ref: subitem.reftable }" @dying="childFSDying($event)"
						></FormSort>
						<FormConfig v-if="htab == hindex && vtab[hindex] == vindex && cfgMode == 'form-cfg'"
							:ctx="{ table: item.table_name, ref: subitem.reftable }" @dying="childFCDying($event)"
						></FormConfig>
                    </v-tab-item>
                </v-tabs>
			</v-tab-item>
		</v-tabs-items>
	</v-card>
	<v-overlay absolute :value="loading">
		<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
	</v-overlay>
	<v-snackbar v-model="snack.active" :color="snack.type"> {{ snack.text }}
		<v-btn text dark @click="snack.active = false">Ok</v-btn>
	</v-snackbar>
	</v-container>
</template>

<script>
	import ListSort from './ListSort'
	import ListConfig from './ListConfig'
	import FormSort from './FormSort'
	import FormConfig from './FormConfig'
	import { mapGetters } from 'vuex'
	export default {
	  	name: 'configs',
		components: { ListSort, ListConfig, FormSort, FormConfig, },
	  	props: {
	  	},
		data() {
			return {
				htab: 1,
				vtab: [],
				/*items: [ 
                    {id: 0, name: '', },
                    {id: 1, name: 'A', items: [ { id: 2, name: 'A1', }, ], },
                    {id: 3, name: 'B', items: [ { id: 4, name: 'B1', }, { id: 5, name: 'B2', } ], }
                ],*/
				msgError: '',
				cfgMode: null,
				isDirty: false,
				loading: false,
				snack: { active: false, type: 'success', text: 'saved',	},
            }
        },
		computed: {
			...mapGetters({
				items: 'configs/getCfgRefTables',
			}),
		},
		methods: {
			fetchData () {
				this.loading = true
				let self = this
				this.$store.dispatch('configs/getCfgRefTables')
				.then((response) => {
					self.vtab = new Array(this.items.length).fill(0);
					self.htab = 0
					self.loading = false
				})
				.catch((error) => {
					console.log(error)
					self.loading = false
				});
			},
			submitDataL(param) {
				this.loading = true	
				let self = this
				this.$store.dispatch('configs/updateCfgLists', param)
				.then((response) => {
					//console.log(response)
					self.isDirty = true
					self.loading = false
				})
				.catch((error) => {
					console.log('CfgLists->submit->error')
					console.log(error)
					self.loading = false
				});
			},
			submitDataF(param) {
				this.loading = true	
				let self = this
				this.$store.dispatch('configs/updateCfgForms', param)
				.then((response) => {
					//console.log(response)
					self.isDirty = true
					self.loading = false
				})
				.catch((error) => {
					console.log('CfgForms->submit->error')
					console.log(error)
					self.loading = false
				});
			},
			htabChanged(e) {
				//console.log('htab changed: ', this.htab, this.vtab)
			},
			childLSDying(e) {
				//console.log('child LS dying: ' + JSON.stringify(e.ctx))
				if(e.ctx.dirty) {
					this.submitDataL(e)
					this.isDirty = false
				}
			},
			childLCDying(e) {
				//console.log('child LC dying: ' + JSON.stringify(e.ctx))
				if(e.ctx.dirty) {
					this.submitDataL(e)
					this.isDirty = false
				}
			},
			childFSDying(e) {
				//console.log('child FS dying: ' + JSON.stringify(e.ctx))
				if(e.ctx.dirty) {
					this.submitDataF(e)
					this.isDirty = false
				}
			},
			childFCDying(e) {
				//console.log('child FC dying: ' + JSON.stringify(e.ctx))
				if(e.ctx.dirty) {
					this.submitDataF(e)
					this.isDirty = false
				}
			},
			cfgModeChanged(e) {
				//console.log('cfgMode: ' + e)
			},
			onReload() {
				this.isDirty = false
				this.fetchCfgs()
			},
			fetchCfgs() {
				this.loading = true
				let self = this
				this.$store.dispatch('core/getCfgs')
				.then((response) => {
					//console.log(response)
					self.loading = false
					self.snack = {active: true, type: 'success', text: 'Cfgs Reload'}
				})
				.catch((error) => {
					console.log(error)
				});
			},
        },
		mounted() {
			this.fetchData ()
		},
	  	watch: {
		},
    }
</script>

<style scoped>
</style>